/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { toTitleCase } from 'sarsaparilla';

function decodeHTML(val: string | null | undefined) {
    let html = val || '';

    if (html) {
        html = html.replace('&#257;', 'ā');
        html = html.replace('&#39;', "'");
        html = html.replace('&amp;', '&');
        html = html.replace('&nbsp;', ' ');
        html = html.replace('&lt;', '<');
        html = html.replace('&gt;', '>');
    }
    return html;
}

export function formatLocationName(name: string) {
    return toTitleCase(decodeHTML(name));
}
